import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import Button from 'react-bootstrap/Button';
import { connect } from 'react-redux';
import Utility from '../../../../Utility/Utility';
import { withRouter } from 'react-router';
import { AgGridReact } from '@ag-grid-community/react';
import { InfiniteRowModelModule } from '@ag-grid-community/infinite-row-model';
import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-alpine.css';
import { chatHistoryList, followUpPost, followUp } from '../Controller/ChatHistoryController';
import moment from 'moment';
import ChatInput from '../Components/ChatInput';
import ChatHistoryInput from '../Components/ChatHistoryInput';

import Chatpanel from '../Components/Chatpanel';
import FollowupPanel from '../Components/FollowupPanel';;
import ModalGlobal from '../../../../Utility/Components/ModalGlobal';
import '../Assets/css/chatlistdoc.scss';
// import '../Assets/css/loginresponsivedoc.scss';
import '../../../../Utility/Public/css/theme.css';
import { DebounceInput } from 'react-debounce-input';
import { loaderStateTrue, loaderStateFalse, handleActiveLink, connectToWebsocket, disconnectToWebsocket } from '../../../../Actions/AllAction';
import MultipleFileUpload from '../../../../Utility/Components/MultipleFileUpload';
import Config from '../../../Utility/Config';
import { Alert } from 'react-bootstrap';
import GlobalHeaderFilter from '../../../../Utility/Components/GlobalHeaderFilter';
import ChatFilterContent from '../../../../Utility/Components/ChatFilterContent';

const ChatList = (props) => {
	// console.log("============props=======>", props)
	const [chatHistory, setChatHistory] = useState([]);
	const [chatHistoryData, setChatHistoryData] = useState([]);
	const [chatHistoryModalFlag, setchatHistoryModalFlag] = useState(false);

	const [followUpModalFlag, setFollowUpModalFlag] = useState(false);
	const [followUpChatInput, setFollowUpChatInput] = useState('');
	const [chatHistoryInput, setChatHistoryInput] = useState('');
	const [paramsData, setParamsData] = useState({});
	const [documentObject, setdocumentObject] = useState([]);
	const [documentObjName, setdocumentObjName] = useState("Choose file");

	const [chatHistoryDocumentObject, setChatHistoryDocumentObject] = useState([]);
	const [chatHistoryDocumentObjName, setChatHistoryDocumentObjName] = useState("Choose file");
	//aggrid //		
	const [scrollblockFlag, setscrollblockFlag] = useState(false);
	const [scrollblockCenter, setscrollblockCenter] = useState(false);

	const [fileUploadFNFlag, setfileUploadFNFlag] = useState(false);
	const [modules, setmodules] = useState([InfiniteRowModelModule]);
	const [searchValue, setSearchValue] = useState("")
	const [chatcount, setchatcount] = useState(0);
	const [defaultColDef, setdefaultColDef] = useState({
		flex: 1,
		//resizable: true,
		minWidth: 50

	});

	const [loading, setLoading] = useState(false);
	const [currentPage, setCurrentPage] = useState(1);


	const [components, setcomponents] = useState({
		loadingRenderer: (params) => {
			if (params.value !== undefined) {
				return params.value;
			} else {
				return '<img src="https://www.ag-grid.com/example-assets/loading.gif">';
			}
		},
	}
	)

	const [gridApi, setGridApi] = useState(null);
	const [gridColumnApi, setGridColumnApi] = useState(null);
	const [gridparams, setgridparams] = useState(null);

	const [columnDefs, setColumnDefs] = useState(
		[
			{
				headerName: "Name",
				field: "profile_name",
				width: 90,

			},
			{
				headerName: "Phone Number",
				field: "phone_number",
				width: 90,
			},
			{
				headerName: "Chat Date",
				field: "chat_date",
				width: 70,
				cellRenderer: (params) => {
					if (params && params.data) {
						if (params.data.chat_date) {
							return <div className="gridusericon">
								{params.data.chat_date}
							</div>
						} else {
							return null;
						}

					} else {
						return null;
					}
				},
			}, {
				headerName: "Chat History",
				field: "action",
				//width: 40,
				cellRenderer: (params) => {
					//   if (params.data && params.data?.status == "enable") {
					return <div className="actionablePopup chatActionBtn">
						<button className="ellipsisIcon" onClick={(e) => actionModalfunction(e, params)}>Show</button>
					</div>
					//   } else {
					// 	return null;
					//   }
				}
			}
			// , {
			// 	headerName: "",
			// 	field: "follow_up",
			// 	width: 40,
			// 	cellRenderer: (params) => {
			// 		//   if (params.data && params.data?.status == "enable") {
			// 		return <div className="actionablePopup chatActionBtn">
			// 			<button className="ellipsisIcon" onClick={(e) => followUpModalfunction(e, params)}>Follow up</button>
			// 		</div>
			// 		//   } else {
			// 		// 	return null;
			// 		//   }
			// 	}
			// }


		]
	)

	useEffect(() => {
		props.handleActiveLink("chat_module", "");
	}, [])

	const onGridReady = useCallback((params) => {
		//const onGridReady = (params) => {

		//console.log("entry onGridReady============")
		setgridparams(params)
		setGridApi(params.api)
		setGridColumnApi(params.columnApi)
		var datasource = serverSideDataSource()

		params.api.setDatasource(datasource);
	});

	const resetDataGrid = () => {
		//console.log("entry resetDataGrid============")
		//gridApi.refreshCells(gridparams);
		// gridApi.purgeServerSideCache(null)
		var datasource = serverSideDataSource()
		gridApi.setDatasource(datasource);
	}


	const serverSideDataSource = () => {
		//console.log("entry serverSideDataSource===============");
		return {
			getRows(params) {
				//console.log("entry getRows===============");
				const { startRow, endRow, filterModel, sortModel } = params
				const { loaderStateTrue, loaderStateFalse } = props;
				loaderStateTrue();
				let filters = {};
				let globalQueryParamshash = {};
				globalQueryParamshash["offset"] = startRow;
				//globalQueryParamshash["limit"] = endRow;
				globalQueryParamshash["limit"] = Config.pageDataLimit;
				globalQueryParamshash["group_by"] = true;
				if (searchValue != "") {
					globalQueryParamshash['search_attr'] = searchValue
					filters['filter_op'] = JSON.stringify({ "search_attr": "substring" })
				}
				filters['filters'] = JSON.stringify(globalQueryParamshash)

				chatHistoryList(filters).then((response) => {
					loaderStateFalse();
					if (response.success) {
						params.successCallback(response.data, response.total);
					} else {
						params.failCallback();
						Utility.toastNotifications(props.t('somethingWwrong'), "Error", "error")
					}
					loaderStateFalse();
				}).catch((error) => {

					response.success
					loaderStateFalse();
				});


			}
		};
	}

	const chatHistoryGetApiCall = () => {

		//console.log('----------', paramsData);
		setLoading(true);
		let filters = {};
		let globalQueryParamshash = {};
		globalQueryParamshash["phone_number"] = paramsData.phone_number;
		globalQueryParamshash["limit"] = 10;
		globalQueryParamshash["offset"] = `${(currentPage - 1) * 10}`;

		filters['filters'] = JSON.stringify(globalQueryParamshash);
		props.loaderStateTrue();
		chatHistoryList(filters).then((response) => {
			if (response.success) {
				setchatcount(response.total)
				//console.log('chatcount----------', chatcount);
				//setChatHistoryData();
				let reverseData = response.data.reverse();
				setChatHistoryData(prevRes => [...reverseData, ...prevRes]);
				setCurrentPage(prevPage => prevPage + 1);
				setLoading(false);
			} else {
				Utility.toastNotifications(that.props.t('somethingWwrong'), "Error", "error")
			}
			props.loaderStateFalse();
		}).catch((error) => {
			//console.log('----------error-------', error);

			props.loaderStateFalse();
		});
	}
	const fllowUpHistoryGetApiCall = (paramData) => {
		let filters = {};
		let globalQueryParamshash = {};
		globalQueryParamshash["phone_number"] = paramData.phone_number;
		filters['filters'] = JSON.stringify(globalQueryParamshash);
		props.loaderStateTrue();
		followUp(filters).then((response) => {
			if (response.success) {
				setChatHistoryData(response.data);
			} else {
				Utility.toastNotifications(that.props.t('somethingWwrong'), "Error", "error")
			}
			props.loaderStateFalse();
		}).catch((error) => {
			//console.log('----------error-------', error);
			props.loaderStateFalse();
		});
	}
	const actionModalfunction = (e, params) => {
		// console.log("params e========", e)
		// console.log("params========", params.data)

		//alert();
		setchatHistoryModalFlag(true);
		setParamsData(params.data);
		setscrollblockFlag(true);
		//chatHistoryGetApiCall(params.data);

	}

	useEffect(() => {
		if (Object.keys(paramsData).length > 0) {
			chatHistoryGetApiCall();
		}
	}, [paramsData])


	const followUpModalfunction = (e, params) => {
		setFollowUpModalFlag(true);
		setParamsData(params.data);
		fllowUpHistoryGetApiCall(params.data);
	}

	useEffect(() => {
		//console.log("chatHistoryData==============", chatHistoryData)
		// console.log('followUpChatInput-------------------->', followUpChatInput)paramsData
	}, [chatHistoryData, followUpChatInput, paramsData, documentObjName, documentObject, chatHistoryDocumentObject, chatHistoryDocumentObjName, chatHistoryInput])

	const chatHistoryModalClose = () => {
		setchatHistoryModalFlag(false);
		setChatHistoryData([]);
		setParamsData({});
		setChatHistoryDocumentObject([]);
		setfileUploadFNFlag(false);
		setCurrentPage(1);
		setscrollblockFlag(false);
	}

	const followUpModalClose = () => {
		setFollowUpModalFlag(false);
		setParamsData({});
		setChatHistoryData([]);
		setdocumentObject([]);
		setfileUploadFNFlag(false);
	}

	const followUpChatInputFn = (e) => {
		setFollowUpChatInput(e.target.value);
	}
	const chatHistoryInputFn = (e) => {
		setChatHistoryInput(e.target.value);
	}

	const sendButttonFn = () => {
		// console.log('=---------followUpChatInput---------------documentObject--------->', followUpChatInput, documentObject)
		if (followUpChatInput != "" || documentObject.length > 0) {
			let data = {};
			// let doc_obj = {};
			data["chat_text"] = followUpChatInput;
			data["phone_number"] = paramsData.phone_number;
			data["profile_name"] = paramsData.profile_name;
			data['followup_by'] = props.userCredentials.id;
			if (documentObject.length > 0) {
				data["doc_obj"] = documentObject.length > 0 ? documentObject[0] : {};
			}
			props.loaderStateTrue();

			followUpPost(data).then((response) => {
				// console.log('-----------response----------->', response)
				if (response.success) {
					Utility.toastNotifications(response.message, "Success", "success")
					// setFollowUpModalFlag(false);
					setdocumentObject([]);
					setFollowUpChatInput("");
					setfileUploadFNFlag(false);
					fllowUpHistoryGetApiCall(paramsData);
				} else {
					params.failCallback();
					Utility.toastNotifications(props.t('somethingWwrong'), "Error", "error")
				}
				props.loaderStateFalse();
			}).catch((error) => {
				//console.log('----------error-------', error);
				props.loaderStateFalse();
			});
		}

		if (followUpChatInput == "") {
			Utility.toastNotifications("Please add text messages", "Warning", "warning")
		}

	}


	const chatHistorySendButttonFn = () => {
		//console.log('-----------chatHistorySendButttonFn---->', chatHistoryInput, chatHistoryDocumentObject);
		if (chatHistoryInput != "" || chatHistoryDocumentObject.length > 0) {
			let data = {};
			// let doc_obj = {};
			data["chat_text"] = chatHistoryInput;
			data["phone_number"] = paramsData.phone_number;
			data["profile_name"] = paramsData.profile_name;
			data['followup_by'] = props.userCredentials.id;
			if (chatHistoryDocumentObject.length > 0) {
				data["doc_obj"] = chatHistoryDocumentObject.length > 0 ? chatHistoryDocumentObject[0] : {};
			}
			props.loaderStateTrue();

			followUpPost(data).then((response) => {
				if (response.success) {
					Utility.toastNotifications(response.message, "Success", "success")
					setChatHistoryDocumentObject([]);
					setChatHistoryInput("");
					setfileUploadFNFlag(false);
					let newchatData = [response["data"]];
					//console.log("newchatData=======", newchatData)
					setChatHistoryData(prevRes => [...prevRes, ...newchatData]);
					//chatHistoryGetApiCall();
				} else {
					params.failCallback();
					Utility.toastNotifications(props.t('somethingWwrong'), "Error", "error")
				}
				props.loaderStateFalse();
			}).catch((error) => {
				//console.log('----------error-------', error);
				props.loaderStateFalse();
			});
		}

		if (chatHistoryInput == "") {
			Utility.toastNotifications("Please add text messages", "Warning", "warning")
		}

	}



	const getBase64 = (file, cb) => {
		let reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = function () {
			cb(reader.result)
		};
		reader.onerror = function (error) {
			//console.log('Error: ', error);
		};
	}


	const dropDocumentFileChange = (files, event) => {
		if (files.length == 1) {
			let fileName = files[0].name.split(".")
			// console.log('fileName======================>',fileName[0])
			let extension = fileName.pop()
			if (extension.toLowerCase() == "pdf" || extension.toLowerCase() == "PDF") {
				const fsize = files[0].size;
				const file = Math.round((fsize / 1024));
				if (file >= 5120) {
					Utility.toastNotifications(props.t('fileUploadAlert'), "Warning", "warning");
				} else {
					getBase64(files[0], (result) => {
						let _hash = {}
						_hash['file_name'] = files[0].name
						_hash['file_obj'] = result
						setdocumentObject([_hash])
					})
				}
			} else {
				Utility.toastNotifications(props.t('fileTypeAlert'), "Warning", "warning");
			}
		} else {
			setdocumentObjName("Choose file")
		}
	}

	const chatHistoryDropDocumentFileChange = (files, event) => {
		if (files.length == 1) {
			let fileName = files[0].name.split(".")
			let extension = fileName.pop()
			if (extension.toLowerCase() == "pdf" || extension.toLowerCase() == "PDF") {
				const fsize = files[0].size;
				const file = Math.round((fsize / 1024));
				if (file >= 5120) {
					Utility.toastNotifications(props.t('fileUploadAlert'), "Warning", "warning");
				} else {
					getBase64(files[0], (result) => {
						let _hash = {}
						_hash['file_name'] = files[0].name
						_hash['file_obj'] = result
						setChatHistoryDocumentObject([_hash])
					})
				}
			} else {
				Utility.toastNotifications(props.t('fileTypeAlert'), "Warning", "warning");
			}
		} else {
			setChatHistoryDocumentObjName("Choose file")
		}
	}

	const uploadMultiDocumentFile = (event) => {
		if (event.target.files.length == 1) {
			let fileName = event.target.files[0].name.split(".")
			let extension = fileName.pop()
			if (extension.toLowerCase() == "pdf" || extension.toLowerCase() == "PDF") {
				const fsize = event.target.files[0].size;
				const file = Math.round((fsize / 1024));
				if (file >= 5120) {
					Utility.toastNotifications(props.t('fileUploadAlert'), "Warning", "warning");
				} else {
					getBase64(event.target.files[0], (result) => {
						let _hash = {}
						_hash['file_name'] = event.target.files[0].name
						_hash['file_obj'] = result
						setdocumentObject([_hash])
					})
				}
			} else {
				Utility.toastNotifications(props.t('fileTypeAlert'), "Warning", "warning");
			}
		} else {
			setdocumentObjName("Choose file")
		}
	}



	const chatHistoryUploadMultiDocumentFile = (event) => {
		if (event.target.files.length == 1) {
			let fileName = event.target.files[0].name.split(".")
			let extension = fileName.pop()
			if (extension.toLowerCase() == "pdf" || extension.toLowerCase() == "PDF") {
				const fsize = event.target.files[0].size;
				const file = Math.round((fsize / 1024));
				if (file >= 5120) {
					Utility.toastNotifications(props.t('fileUploadAlert'), "Warning", "warning");
				} else {
					getBase64(event.target.files[0], (result) => {
						let _hash = {}
						_hash['file_name'] = event.target.files[0].name
						_hash['file_obj'] = result
						setChatHistoryDocumentObject([_hash])
					})
				}
			} else {
				Utility.toastNotifications(props.t('fileTypeAlert'), "Warning", "warning");
			}
		} else {
			setChatHistoryDocumentObjName("Choose file")
		}
	}

	const removeDoc = (i) => {
		let documentObjectArryTemp = documentObject.slice();
		documentObjectArryTemp.splice(i, 1);
		setdocumentObject(documentObjectArryTemp)
	}

	const chatHistoryRemoveDoc = (i) => {
		let chatHistoryDocumentObjectArryTemp = chatHistoryDocumentObject.slice();
		chatHistoryDocumentObjectArryTemp.splice(i, 1);
		setChatHistoryDocumentObject(documentObjectArryTemp)
	}
	const fileUploadFN = () => {
		setfileUploadFNFlag(fileUploadFNFlag => !fileUploadFNFlag);

	}

	const loadGrid = () => {
		//console.log("entry============")
		resetDataGrid();
	}

	const handleUserSearchBar = (e) => {
		const { value } = e.target;
		setSearchValue(value)
		// console.log("searchValue", value)
	}

	useEffect(() => {
		if (searchValue.length > 1) {
			resetDataGrid()
		}
		if (searchValue.length == 0 && gridparams) {
			resetDataGrid()
		}
	}, [searchValue])

	const clearSearchValue = () => {
		setSearchValue("")
		resetDataGrid()
	}

	const handleScroll = (e) => {

		//console.log("Entry Call server side scroll");

		const { scrollTop, clientHeight, scrollHeight } = e.currentTarget;

		/*console.log("scrollTop=======", scrollTop);
		console.log("loading=======", loading);
		console.log("currentPage=======", currentPage);*/

		if (scrollTop === 0 && !loading && currentPage > 1) {
			if (chatHistoryData.length < chatcount) {
				//console.log("Call server side scroll");
				//fetchMessages();
				chatHistoryGetApiCall();
				setscrollblockCenter(true);
			}
			setscrollblockFlag(false)
		}
	}
	useEffect(() => {
		// 	console.log('chatHistoryData--123--------', chatHistoryData.length);
		// console.log('chatcount----123------', chatcount);
	}, [chatHistoryData, chatHistoryData])


	const messageRef = useRef();
	useEffect(() => {
		if (scrollblockCenter) {
			//console.log("entry======scroll ref====")
			if (messageRef.current) {
				messageRef.current.scrollIntoView(
					{
						behavior: 'smooth',
						block: scrollblockFlag ? 'end' : 'center',
						inline: 'nearest'
					})
			}
		}
	}, [scrollblockCenter])
	//console.log("scrollblockFlag---------", scrollblockFlag);
	//console.log("scrollblockCenter---------", scrollblockCenter);

	const gridOptions = useMemo(
		() => ({
			infiniteInitialRowCount: 1,
			onGridReady,
			paginationPageSize: 100,
			rowBuffer: 0,
			rowModelType: 'infinite',
			suppressCellSelection: true,
			suppressHorizontalScroll: true,
		}),
		[]
	)


	return (
		<div className="gridcontainer questionAgGrid">
			<GlobalHeaderFilter
				headerFliterContent={
					<>
						<ChatFilterContent
							handleUserSearchBar={handleUserSearchBar}
							searchValue={searchValue}
							clearSearchValue={clearSearchValue}
						/>
					</>
				}
			/>
			<div className='grid_content_inner' style={{ position: 'relative' }}>
				<div className="ag-theme-alpine aggridview agprises version1">
					<div className="leadButtonInner"><button className="buttonload" onClick={() => { loadGrid() }}>
						<i className="fa fa-refresh"></i>Refresh data
					</button></div>
					<AgGridReact
						modules={modules}
						columnDefs={columnDefs}
						defaultColDef={defaultColDef}
						components={components}
						//rowSelection="multiple"
						rowModelType="infinite"
						onGridReady={onGridReady}
						rowHeight={62.5}
						headerHeight={47}
						cacheBlockSize={Config.pageDataLimit}
						gridOptions={gridOptions}
					/>
				</div>
			</div>
			<ModalGlobal
				show={chatHistoryModalFlag}
				onHide={chatHistoryModalClose}
				title={`Chat History: ${paramsData.profile_name} ( ${paramsData.phone_number} )`}
				className="modalcustomize mondimension modalWithGrid chatModal"
				footer={true}
				closeButton={true}
				saveShow={false}
				body={
					<Chatpanel
						chatHistoryData={chatHistoryData}
						handleScroll={handleScroll}
						messageRef={messageRef}
					/>
				}
				cancelShow={false}
				footerContent={

					<>
						<div className='fileUploadButtonSec'>
							<button className='fileUploadButton' data-tip="File Upload" onClick={fileUploadFN}>  {fileUploadFNFlag ? <span>-</span> : <span>+</span>} File Upload <span style={{ color: 'red', fontSize: '13px' }}>(* pdf only)</span> </button>
						</div>
						{fileUploadFNFlag ?
							<MultipleFileUpload
								documentObjName={chatHistoryDocumentObjName}
								onDrop={chatHistoryDropDocumentFileChange}
								onChange={chatHistoryUploadMultiDocumentFile}
								// submit={this.props.documentSubmit}
								documentObject={chatHistoryDocumentObject}
								removeDoc={chatHistoryRemoveDoc}
							/> : null}
						<ChatHistoryInput
							chatHistoryInputFn={chatHistoryInputFn}
							chatHistorySendButttonFn={chatHistorySendButttonFn}
							chatHistoryInput={chatHistoryInput}
						/>
					</>
				}
			/>


			<ModalGlobal
				show={followUpModalFlag}
				onHide={followUpModalClose}
				title="Follow Up"
				className="modalcustomize mondimension modalWithGrid chatModal"
				footer={true}
				closeButton={true}
				saveShow={false}
				body={
					<FollowupPanel
						chatHistoryData={chatHistoryData} />
				}
				cancelShow={false}
				footerContent={
					<>
						<div className='fileUploadButtonSec'>
							<button className='fileUploadButton' data-tip="File Upload" onClick={fileUploadFN}>  {fileUploadFNFlag ? <span>-</span> : <span>+</span>} File Upload (<span style={{ color: 'red' }}>*</span>pdf only) </button>
						</div>
						{fileUploadFNFlag ?
							<MultipleFileUpload
								documentObjName={documentObjName}
								onDrop={dropDocumentFileChange}
								onChange={uploadMultiDocumentFile}
								// submit={this.props.documentSubmit}
								documentObject={documentObject}
								removeDoc={removeDoc}
							/> : null}
						<ChatInput
							followUpChatInputFn={followUpChatInputFn}
							sendButttonFn={sendButttonFn}
							followUpChatInput={followUpChatInput}
						/>
					</>
				}
			/>
		</div>
	);
}




const mapStateToProps = (globalState) => {
	return {
		userCredentials: globalState.LoginReducer.userCredentials,
		token: globalState.LoginReducer.token
	};
}

export default connect(mapStateToProps, { handleActiveLink, loaderStateTrue, loaderStateFalse, })(withRouter(ChatList));


